package com.patronat.top.features.dashboard.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewListResponse
import com.patronat.top.features.dashboard.domain.repository.ReviewModerationRepository
import com.patronat.top.features.dashboard.domain.usecase.command.GetReviewModerationQueueCommand

class GetReviewModerationQueueUseCase(
    private val repository: ReviewModerationRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetReviewModerationQueueCommand, DomainResult<ReviewListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetReviewModerationQueueCommand): DomainResult<ReviewListResponse> {
        return repository.getReviews(command.request)
    }
}
